export const getColorClass = (engagement) => {
    let className = 'has-gray-light-color'
    if(engagement === 'engaged') {
        className = 'has-green-color'
    } else if(engagement === 'declined') {
        className = 'has-yellow-color'
    } else if(engagement === 'adopted') {
        className = 'has-blue-color'
    } else if(engagement === 'unresponsive') {
        className = 'has-gray-color'
    }
    return className
}